import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { playVideoAction } from '../actions/action-creators';
import CardVideo from './CardVideo';
import { mediaBreakpointUpMD } from '../constants/style-constants';
import { vunit } from '../lib/style-helpers';

const titleCss = css`
  display: block;
  margin-bottom: ${vunit(1)};

  ${mediaBreakpointUpMD} {
    display: none;
  }
`;

const TableVideoCard = ({
  sessionId,
  specialOpsVideoUrl,
  playEventId,
  title,
  isVideoBeingProcessed,
  noVideoMessage,
}) => {
  const dispatch = useDispatch();

  const handleVideoPlay = ({ target }) => {
    dispatch(playVideoAction({
      eventTarget: target,
      eventId: playEventId,
    }));
  };

  return (
    <>
      <span css={titleCss}>{title}</span>
      {sessionId
        ? (
          <CardVideo
            isVideoBeingProcessed={isVideoBeingProcessed}
            sessionId={sessionId}
            videoUrlPath={specialOpsVideoUrl}
            onPlay={handleVideoPlay}
          />
        )
        : (
          <div>
            {noVideoMessage}
          </div>
        )
      }
    </>
  );
};

TableVideoCard.defaultProps = {
  sessionId: null,
};

TableVideoCard.propTypes = {
  title: PropTypes.string.isRequired,
  noVideoMessage: PropTypes.string.isRequired,
  playEventId: PropTypes.string.isRequired,
  sessionId: PropTypes.string,
  specialOpsVideoUrl: PropTypes.string.isRequired,
  isVideoBeingProcessed: PropTypes.bool.isRequired,
};

export default TableVideoCard;
